import {v4 as uuidv4} from 'uuid';
import store from "../../store";
import getProductBySKU from "../../services/getProductBySKU";
import mapProductData from "./mapProductData";
import mapOptionList from "./mapOptionList";
import loadVariant from "./loadVariant";
import startModification from "../internal/sections/startModification";
import priceCalculator from "../order/price/priceCalculator";
import getShareDesign from "../../services/getShareDesign";
import alert from "../../components/assets/alert";
import closeCustomizationModal from "../order/closeCustomizationModal";


export default async function getProduct() {


    const url = new URL(window.location.href);
    const queryParams = new URLSearchParams(url.search);
    const storeName = queryParams.get('store_name')
    const sku = queryParams.get('sku')
    const development = queryParams.get('development')
    const shareId = queryParams.get('shareId')
    

    const productBySKU = await getProductBySKU(sku, storeName)
    if (!productBySKU || productBySKU?.length === 0) {
        alert.showAlert({
            title: "Error :(",
            message: `Product with SKU "${sku}" was not found. Please close the customizer and choose another product.`,
            button: "OK",
            onclick: () => {
                closeCustomizationModal();
            },
            cancel: false
        });
        
        store.status.error = "Product not found";
        return;
    }

    const variantListFromApi = mapProductData(productBySKU);
    const setStore = (list) => {

        store.variantsOptions = mapOptionList(list);
        store.variants = list;
    }

    if (development) {

        setStore(variantListFromApi);
        await loadVariant(sku);
        store.order.modification_id =  uuidv4()
		store.storeUrl = queryParams.get('storeUrl')
		//console.log("store.storeUrl", store.storeUrl)
        //await startModification({}, uuidv4())
		
		if (shareId) {
			const modification_data = await getShareDesign({storeName, shareId, sku})
			if (modification_data) {
				modification_data['_data'] = modification_data['section_string']
				await startModification(modification_data, shareId)
			}
			
		}
		
		
		
        return;
    }
    
    

    const handleMessage = async (msg) => {
        const data = msg?.data
        if (data.hasOwnProperty('product-data') && typeof data?.['product-data'] === 'object') {


            const productData = data['product-data'];
            const ProductVariants = productData?.variants;

            
            const filteredList = []
            
            ProductVariants.forEach(variant => {
                const mappedVariant = variantListFromApi?.find(item => item.sku === variant.sku);
                
                if (
                    variant.has_customization === "true" &&
                    variant.available &&
                    variant.inventory_quantity > 0
                ) {
                    filteredList.push({
                        ...mappedVariant,
                        ...variant
                    })
                }
                
            });

            setStore(filteredList);
			
			await loadVariant(sku);
			
			
			
            if (productData?.["modification_data"] || productData?.["modification_id"]) {
                await startModification(productData?.["modification_data"], productData?.["modification_id"])
            }

			
			//console.log("shareId", shareId)

            if (shareId) {
                const modification_data = await getShareDesign({storeName, shareId, sku})
				if (modification_data) {
					modification_data['_data'] = modification_data['section_string']
					await startModification(modification_data, shareId)
				}
            
            }


            
            store.order = {
                modification_id: productData?.["modification_id"] || uuidv4(),
                isModified: !!productData?.["modification_id"],
                store_name: storeName,

                eching_sections: "0",
                neatolabsCost: "0",
                quantity: Number(productData?.["quantity"]),

                product_id: productData?.["id"],
                variant_id: productData?.["variant_id"]
            };
            store.storeUrl = data?.storeUrl
            priceCalculator();
        }


    }
    window.removeEventListener('message', handleMessage)
    window.addEventListener('message', handleMessage)
    window.parent.postMessage({"product-data": true}, "*");
}